import React, { useState, useEffect } from 'react'
import { CaretDown } from '@phosphor-icons/react'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'

const DropdownButton = ({
  className = 'dropdown-btn-style',
  label = '',
  defaultOption = '',
  caretSize = 20,
  useLabelName = undefined,
  optionListWidth = 'min-w-20',
  options,
  onClick,
  noShadows = false,
}) => {
  const [selectedOption, setSelectedOption] = useState(defaultOption)

  useEffect(() => {
    onClick(selectedOption)
  }, [selectedOption])

  return (
    <React.Fragment>
      <Menu as="div" className="relative">
        <div>
          <MenuButton className={`inline-flex w-full gap-x-1 md:gap-x-1.5 ${!noShadows && 'shadow-sm'} hover:bg-gray-50 ${className}`}>
            <div className='flex flex-nowrap gap-x-1 md:gap-x-3 justify-between items-center w-full'>
              { label && label }
              { useLabelName ? selectedOption[useLabelName] : selectedOption?.label }
              <CaretDown size={caretSize} weight='light' />
            </div>
          </MenuButton>
        </div>

        <MenuItems
          transition
          className={`absolute right-0 z-10 mt-2 ${optionListWidth} origin-top-right bg-white shadow-lg ring-1 ring-black ring-opacity-5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in`}
        >
          <div className="">
            {
              options?.map((item) => {
                return (
                  <MenuItem className='cursor-pointer hover:bg-slate-50/75 px-3 py-2' key={`dp-${item.id}`} onClick={() => {
                    setSelectedOption(item)
                  }}>
                    <div>{useLabelName ? item[useLabelName] : item.label}</div>
                  </MenuItem>
                );
              })
            }
          </div>
        </MenuItems>
      </Menu>
    </React.Fragment>
  );
}

export default DropdownButton
